"use strict";
/**
 * Registration inclusion for Tour Builder ops and capacity-related filters.
 * Players with a linked EventScore stay included even if refunded / WD / DQ
 * (played then stopped).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.registrationHasEventScore = registrationHasEventScore;
exports.isOpsActiveRegistration = isOpsActiveRegistration;
function registrationHasEventScore(reg) {
    return Boolean(reg?.eventScoreID);
}
/** TB ops: tee sheet, emails, score build, roster sync, admin counts */
function isOpsActiveRegistration(reg) {
    // Played (has EventScore) wins — covers refunded after WD/DQ / stopped play
    if (registrationHasEventScore(reg))
        return true;
    if (reg.canceled || reg.withdrawn || reg.disqualified || reg.refunded)
        return false;
    return true;
}
